import { useIntl } from 'react-intl';
import FiltroChip from 'src/componentes/filtro-chip';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';
import { CRITERIOS_PUBLICO_INTERESSADO_PADRAO } from './publicoInteressadoDocumento';

export default function PublicoInteressadoCriteriosChips({
  criterios,
  hasLift,
  disabled,
  onChange,
}) {
  const intl = useIntl();
  const { terms } = useAuth();
  const activeFilter = {};
  const labels = {
    tempoMinimoCargoDias: intl.formatMessage(
      { id: 'labelTempoMinimoCargoDias' },
      { cargo: terms.cargo }
    ),
    tempoMinimoEmpresaDias: intl.formatMessage({
      id: 'labelTempoMinimoEmpresaDias',
    }),
    cargos: capitalizeFirstLetter(terms.cargos),
    areas: capitalizeFirstLetter(terms.areas),
    considerarAreasSubordinadas: intl.formatMessage(
      { id: 'labelConsiderarAreasSubordinadasPublico' },
      { areas: terms.areas }
    ),
    colaboradores: capitalizeFirstLetter(terms.colaboradores),
  };

  if (hasLift && criterios.tempoMinimoCargoDias != null) {
    activeFilter.tempoMinimoCargoDias = {
      nome: intl.formatNumber(criterios.tempoMinimoCargoDias),
    };
  }
  if (criterios.tempoMinimoEmpresaDias != null) {
    activeFilter.tempoMinimoEmpresaDias = {
      nome: intl.formatNumber(criterios.tempoMinimoEmpresaDias),
    };
  }
  if (hasLift && criterios.cargos?.length)
    activeFilter.cargos = criterios.cargos;
  if (criterios.areas?.length) {
    activeFilter.areas = criterios.areas;
    if (criterios.considerarAreasSubordinadas) {
      activeFilter.considerarAreasSubordinadas = true;
    }
  }
  if (criterios.colaboradores?.length) {
    activeFilter.colaboradores = criterios.colaboradores;
  }

  const remove = (field) => {
    if (disabled) return;
    onChange({
      ...criterios,
      [field]: CRITERIOS_PUBLICO_INTERESSADO_PADRAO[field],
      ...(field === 'areas' ? { considerarAreasSubordinadas: false } : {}),
    });
  };

  if (!Object.keys(activeFilter).length) return null;

  return (
    <div className="tw:mt-4 tw:min-w-0">
      <div className="tw:mb-2 tw:text-sm tw:font-medium">
        {intl.formatMessage({ id: 'labelCriteriosAtivos' })}
      </div>
      <FiltroChip
        selectedFilter={activeFilter}
        onRemoveSaveFilter={false}
        preventRemoveFilterChip={() => disabled}
        onRemoveFilterChip={remove}
        getFilterChipLabel={(field, selectedValue) => {
          if (field === 'considerarAreasSubordinadas') return labels[field];
          const description = Array.isArray(selectedValue)
            ? selectedValue
                .map((item) => item.nome ?? item.descricao)
                .join(', ')
            : selectedValue.nome;
          return `${labels[field]}: ${description}`;
        }}
      />
    </div>
  );
}
